import React, { useState, useEffect, Dispatch } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  Input,
  Button,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EventsData } from '../../types/types';
import { fetchResultadosBusqueda } from '../../reducer/config-reducer';
import { resetPasosCompra } from '../../reducer/events-reducer';
import Spinner from './Spinner';
import {
  flattenResultadosBusqueda,
  pathResultadoBusqueda,
  ResultadoBusqueda,
  TIPOS_RESULTADO_DESKTOP
} from '../../utilities/resultadosBusqueda';

interface propiedades {
  fetchResultadosBusqueda: Dispatch<string>,
  resetPasosCompra: Dispatch<void>,
  resultadosBusqueda: EventsData,
  buscandoResultados: boolean
}

interface configObjectResultados {
  configReducer: {
    resultadosBusqueda: EventsData,
    buscandoResultados: boolean,
  }
}

// Buscador de la home cuando corre la pre-home estatica: sin busqueda por fecha
// y con el primer resultado marcado, para poder entrar con Enter.
const BuscadorHome = (props: propiedades) => {
  const [textToSearch, setTextToSearch] = useState<string>('');
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const navigate = useNavigate();

  const resultados = flattenResultadosBusqueda(props.resultadosBusqueda, TIPOS_RESULTADO_DESKTOP);
  const resultadoMarcado: ResultadoBusqueda | undefined = resultados[selectedIndex];

  useEffect(() => {
    // cada vez que llegan resultados nuevos queda marcado el primero
    setSelectedIndex(0);
    setDropdownOpen(flattenResultadosBusqueda(props.resultadosBusqueda, TIPOS_RESULTADO_DESKTOP).length > 0);
  }, [props.resultadosBusqueda]);

  const searchHandler = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setTextToSearch(evt.target.value);
    // con menos de 2 caracteres limpiamos los resultados anteriores
    props.fetchResultadosBusqueda(evt.target.value.length > 1 ? evt.target.value : '');
  }

  const navigateEventsHandler = () => {
    navigate(`/eventos?k=${textToSearch}`);
  }

  const irAResultado = (resultado: ResultadoBusqueda) => {
    setTextToSearch(resultado.title);
    setDropdownOpen(false);

    if (resultado.tipo === 'Eventos') {
      props.resetPasosCompra();
    }

    navigate(pathResultadoBusqueda(resultado));
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!dropdownOpen || resultados.length === 0) {
      // sin resultados desplegados el Enter no hace nada
      if (event.key === 'Enter') {
        event.preventDefault();
      }
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setSelectedIndex((prev) => (prev + 1) % resultados.length);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setSelectedIndex((prev) => (prev - 1 + resultados.length) % resultados.length);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      irAResultado(resultadoMarcado || resultados[0]);
    }
  }

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  }

  return (
    <>
      <Row className='w-100 d-flex justify-content-center'>
        <Col className='bg-white rounded d-flex align-items-center justify-content-center buscador buscador-home'>
          <div style={{ "flex": "1" }}>
            <Input
              placeholder='Buscar por Evento, Artista, Sala, ...'
              className='border-0 p-1'
              value={textToSearch}
              onChange={searchHandler}
              onKeyDown={handleKeyDown}
            />
            <div className='resultados-busqueda'>
              <Dropdown isOpen={dropdownOpen || props.buscandoResultados} toggle={toggleDropdown}>
                <DropdownMenu>
                  <DropdownToggle tag="span"></DropdownToggle>
                  {props.buscandoResultados && <Spinner style={{ "top": "10%", "left": "32%", "transform": "scale(0.7)" }} />}
                  {!props.buscandoResultados && <ul>
                    {TIPOS_RESULTADO_DESKTOP.map((tipo) => {
                      const delTipo = resultados.filter((resultado) => resultado.tipo === tipo);

                      if (delTipo.length === 0) {
                        return null;
                      }

                      return (
                        <li key={tipo}>
                          <p className='text-muted text-uppercase'>{tipo}</p>
                          <ul>
                            {delTipo.map((resultado) => {
                              const index = resultados.indexOf(resultado);

                              return (
                                <li
                                  key={`${tipo}-${resultado.id}`}
                                  className={index === selectedIndex ? 'marcado' : ''}
                                  onMouseEnter={() => { setSelectedIndex(index) }}
                                  onClick={() => { irAResultado(resultado) }}
                                >{resultado.title}</li>
                              );
                            })}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
          <div className='pe-2'>
            <Button color='link' className='p-0 btn-search' onClick={navigateEventsHandler} disabled={textToSearch === ''} style={{ "color": "#333" }}><SearchIcon /></Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='text-white text-center home-subtitle'>
          <h3>¡Busca el Evento y consigue tus Lugares!</h3>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state: configObjectResultados) => {
  return {
    resultadosBusqueda: state.configReducer.resultadosBusqueda,
    buscandoResultados: state.configReducer.buscandoResultados,
  }
}
export default connect(
  mapStateToProps,
  { fetchResultadosBusqueda, resetPasosCompra }
)(BuscadorHome);
